import {
    useGetCommercialAttachmentsQuery,
    useGetComparisonAttachmentsQuery,
    useGetComparsionQuery,
    usePostAddComparisonMutation,
} from '../../../../store/api/bidComparsion'
import { useParams } from 'react-router-dom'
import {
    Box,
    Collapse,
    Divider,
    FormControl,
    Grid,
    Hidden,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { BusinessUnit, EntryDate, RFQDate } from '../../../../components/SelectBox'
import { CommonTextBox } from '../../../../components/TextBox'
import {
    bidComparsionApprovalStatuses,
    bidComparsionStatuses,
    biddingTypes,
    emergencies,
} from '../../../../constDatas/constDatas'
import { useGetBuyersQuery, useGetRFQSingleReasonsQuery } from '../../../../store/api/rfqsApi'
import RFQDeadline from '../../../../components/SelectBox/RFQDeadLine'
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined'
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined'
import PaginationSystem from '../../../../components/Pagination/PaginationSystem'
import DatePicker from '../../../../components/CustomInputs/DatePicker'
import RFQBuyers from '../../../../components/SelectBox/RFQBuyers'
import BidChart from '../chart'
import ApprovalInformations from '../chart/ApprovalInformations'
import SelectForm from '../../../../components/SelectBox/SelectForm'
import TextForm from '../../../../components/TextBox/TextForm'
import { useDispatch, useSelector } from 'react-redux'
import {
    updateComparsionChartData,
    updateSelectedGridData,
    updateSelectedLines,
    updateSelectedSequence,
} from '../../../../store/slice/bidComparsionChart'
import SaveDialog from '../../../../components/Dialog/SaveDialog'
import { hideSaveDialog } from '../../../../store/slice/dialogSlice'
import { useGetApprovalStagesQuery } from '../../../../store/api/approvalApi'
import { showErrorToast, showSuccessToast } from '../../../../constToast/constToast'
import ConfirmDialog from '../../../../components/Dialog/ConfirmDialog'
import DataSelector from '../../../../components/CustomInputs/DataSelector'
import CreatePODialog from '../../../../components/Dialog/CreatePODialog'
import moment from 'moment'
import UploadDialog from '../../../../components/Dialog/UploadDialog'
import { validateAttachments } from '../../../../components/Dialog/attachmentValidation'
import { useGetBIDsAttachmentsQuery } from '../../../../store/api/bidsApi'
import UploadDialogInner from '../../../../components/Dialog/UploadDialogInner'
import UploadDialogMain from '../../../../components/Dialog/UploadDialogMain'
import { updateAttachmentCount } from '../../../../store/slice/mainToCardSlice'

const Card = () => {
    let xlGrid1, xlGrid2, lgGrid1, lgGrid2, mdGrid1, mdGrid2, smGrid1, smGrid2, xsGrid1, xsGrid2
    let xlColumn, lgColumn, mdColumn, smColumn, xsColumn
    const [open, setOpen] = useState(true)

    const [bidMainId, setBidMainId] = useState([])
    const [attachments, setAttachments] = useState([])
    const [attachmentsBidC, setAttachmentsBidC] = useState([])
    const [commercialAttachments, setCommercialAttachments] = useState([])

    xlGrid1 = open ? 8 : 11.4
    xlGrid2 = open ? 3 : 0.5

    lgGrid1 = open ? 8 : 11
    lgGrid2 = open ? 4 : 1

    mdGrid1 = open ? 12 : 12
    mdGrid2 = open ? 12 : 12

    smGrid1 = open ? 12 : 12
    smGrid2 = open ? 12 : 12

    xsGrid1 = open ? 12 : 12
    xsGrid2 = open ? 12 : 12

    //Column
    xlColumn = 2
    lgColumn = open ? 2.5 : 2.5
    mdColumn = 3
    smColumn = 5
    xsColumn = 12
    const defaultValues = {
        comparisondeadline: new Date(),
        comparisonDate: new Date(),
    }
    const {
        handleSubmit,
        control,
        getValues,
        watch,
        reset,
        formState: { errors },
    } = useForm({ defaultValues })
    const { dataId } = useParams()
    const { data: comparsionData, refetch, isLoading } = useGetComparsionQuery(dataId)
    const { data: singleSourceReasons } = useGetRFQSingleReasonsQuery()
    const [businessUnitCode, setBusinessUnitCode] = useState(null)
    const { data: buyers, refetch: refetchBuyers } = useGetBuyersQuery(watch()?.businessUnitId)
    const { data: approvalStages, refetch: refetchStages } = useGetApprovalStagesQuery({
        businessUnitId: watch('businessUnitId'),
        procedureKey: 'BID',
    })

    const {
        data: attachmentsData,
        error,
        refetch: refetchAttachments
    } = useGetComparisonAttachmentsQuery(getValues().bidComparisonId)
    const { data: attachmentsDataBidC } = useGetBIDsAttachmentsQuery({ sourceId: bidMainId })
    const { data: attachmentsCommercialData, refetch: refetchAttachmentsCommercial } =
        useGetCommercialAttachmentsQuery(bidMainId)

    const dispatch = useDispatch()
    const [postAddComparison] = usePostAddComparisonMutation()
    const refreshClicked = useSelector((state) => state.buttonSlice.refreshClicked)

    const handleClick = () => {
        setOpen(!open)
    }

    const handleSave = async () => {
        // fileLink-i olmayan attachment save-e getmemelidir
        if (!validateAttachments(attachments)) {
            return
        }

        const res = await postAddComparison({
            ...getValues(),
            singleSourceReasonId: getValues()?.singleSourceReasonId,
            comparisonDate: moment(new Date(getValues()?.comparisonDate)).format('YYYY-MM-DD'),
            comparisondeadline: moment(new Date(getValues()?.comparisondeadline)).format('YYYY-MM-DD'),
            attachments,
        })
        if (res?.data.statusCode == 200) {
            refetch()
            dispatch(hideSaveDialog())
            showSuccessToast(`${getValues()?.comparisonNo || ''} Successfully updated`)
        } else {
            showErrorToast('Error')
        }
    }
    useEffect(() => {
        if (!isLoading) {
            reset({
                ...comparsionData?.data?.bidComparisonHeader,
                rfqSingleSourceReasons: comparsionData?.data?.bidComparisonHeader?.rfqSingleSourceReasons?.map(
                    (item) => item?.singleSourcereasonId
                ),
                singleSourceReasonId: comparsionData?.data?.bidComparisonHeader?.singleSourceReasons?.map(
                    (item) => item?.singleSourcereasonId
                ),
            })
            const newData = { ...comparsionData?.data }
            const rfqDetails = [...newData?.rfqDetails].sort((a, b) => a.rfqDetailId - b.rfqDetailId)
            const bids = [...newData?.bids]?.map((item) => {
                const bidDetails = [...item?.bidDetails].sort((a, b) => a.rfqDetailId - b.rfqDetailId)
                return {
                    ...item,
                    bidDetails,
                }
            })
            dispatch(
                updateComparsionChartData({
                    ...newData,
                    rfqDetails,
                    bids,
                })
            )
            dispatch(updateSelectedGridData([comparsionData?.data?.bidComparisonHeader]))
        }
    }, [isLoading, comparsionData])

    useEffect(() => {
        refetchBuyers()
    }, [watch()?.businessUnitId])

    useEffect(() => {
        refetch()
    }, [refreshClicked])
    useEffect(() => {
        return () => {
            dispatch(updateSelectedLines({}))
            dispatch(updateSelectedSequence(null))
            dispatch(updateComparsionChartData({}))
        }
    }, [])
    const chartData = useSelector((state) => state.bidComparsionSlice.comparsionChartData)

    const hasOneChart = chartData?.bids?.length > 1

    // Attachment Count
    useEffect(() => {
        if (attachments?.length > 0) {
            dispatch(updateAttachmentCount(attachments?.length))
        } else {
            dispatch(updateAttachmentCount(0))
        }
    }, [attachments, dispatch])


    return (
        <Grid container mt={2}>
            <SaveDialog text="Bid Comparison" handleSave={handleSubmit((data) => handleSave(data))} />
            <ConfirmDialog refetch={refetch} businessUnitId={watch('businessUnitId')} />
            <CreatePODialog />
            <UploadDialog
                module={'BidComparison'}
                value={attachments}
                setValue={setAttachments}
                initialData={attachmentsData?.data}
                onlyView={chartData?.bidComparisonHeader?.status != 0}
            />
            <UploadDialogMain
                module={'BidComparison'}
                value={attachmentsBidC}
                setValue={setAttachmentsBidC}
                initialData={attachmentsDataBidC?.data}
                onlyView={true}
            />
            <UploadDialogInner
                module={'BidComparison'}
                value={commercialAttachments}
                setValue={setCommercialAttachments}
                initialData={attachmentsCommercialData?.data}
                onlyView={true}
            />
            <Box sx={{ width: '100%', typography: 'body1' }}>
                <form onSubmit={handleSubmit(handleSave)} id="bid-chart-form">
                    <Grid container display="flex" justifyContent="space-between">
                        <Grid item xs={xsGrid1} sm={smGrid1} md={mdGrid1} lg={lgGrid1} xl={xlGrid1}>
                            <Grid container display="flex" justifyContent="space-between" spacing={2}>
                                <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            rules={{ required: true }}
                                            render={({ field: { value, onChange } }) => (
                                                <BusinessUnit setCode={setBusinessUnitCode} disabled value={value}
                                                    setValue={onChange} />
                                            )}
                                            control={control}
                                            name="businessUnitId"
                                        />
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            render={({ field: { value, onChange } }) => (
                                                <CommonTextBox label="RFQ No" disabled value={value}
                                                    setValue={onChange} />
                                            )}
                                            control={control}
                                            name="rfqNo"
                                        />
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <SelectForm
                                            data={biddingTypes}
                                            disabled
                                            label="Bidding Type"
                                            control={control}
                                            name="label"
                                            id="value"
                                            dynamicField="biddingType"
                                        />
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            rules={{ required: !hasOneChart }}
                                            render={({ field: { value, onChange } }) => (
                                                <DataSelector
                                                    disabled={watch('status') != 0 || hasOneChart}
                                                    data={singleSourceReasons?.data}
                                                    value={value}
                                                    onChange={onChange}
                                                    label="Single Source"
                                                    valueKey="id"
                                                    labelKey="singleSourceReason"
                                                    error={errors?.singleSourceReasonId}
                                                />
                                            )}
                                            name="singleSourceReasonId"
                                            control={control}
                                        />
                                    </Box>
                                    <Box sx={{ pb: 2 }}>
                                        <SelectForm
                                            data={bidComparsionStatuses}
                                            disabled
                                            label="Status"
                                            control={control}
                                            name="statusName"
                                            id="statusId"
                                            dynamicField="status"
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            render={({ field: { value, onChange } }) => (
                                                <RFQDate disabled error={errors?.rfqDate} value={value}
                                                    setRfqDate={onChange} />
                                            )}
                                            control={control}
                                            name="rfqDate"
                                        />
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            render={({ field: { value, onChange } }) => (
                                                <RFQDeadline disabled error={errors?.rfqDeadline} value={value}
                                                    setRfqDate={onChange} />
                                            )}
                                            control={control}
                                            name="rfqDeadline"
                                        />
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            render={({ field: { value, onChange } }) => (
                                                <FormControl size="small" fullWidth>
                                                    <InputLabel>Emergency</InputLabel>
                                                    <Select
                                                        label="Emergency"
                                                        value={value || ''}
                                                        size="small"
                                                        fullWidth
                                                        disabled
                                                        style={{
                                                            color: 'black !important',
                                                            background: 'hsl(0, 0%, 95%)',
                                                        }}
                                                    >
                                                        {emergencies.map((item) => (
                                                            <MenuItem key={item.value} value={item.label}>
                                                                <Box display="flex" gap={1} alignItems="center">
                                                                    <span>{item.label}</span>
                                                                    {item.icon}
                                                                </Box>
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            )}
                                            control={control}
                                            name="emergency"
                                        />
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            render={({ field: { value, onChange } }) => (
                                                <DataSelector
                                                    disabled={watch('status') != 0}
                                                    data={singleSourceReasons?.data}
                                                    value={value}
                                                    onChange={onChange}
                                                    forView
                                                    label="RFQ Single Source"
                                                    valueKey="id"
                                                    labelKey="singleSourceReason"
                                                />
                                            )}
                                            name="rfqSingleSourceReasons"
                                            control={control}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            render={({ field: { value, onChange } }) => (
                                                <CommonTextBox disabled label="Entered By" value={value}
                                                    setValue={onChange} />
                                            )}
                                            control={control}
                                            name="enteredBy"
                                        />
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            render={({ field: { value, onChange } }) => (
                                                <CommonTextBox disabled label="Comparison" value={value}
                                                    setValue={onChange} />
                                            )}
                                            control={control}
                                            name="comparisonNo"
                                        />
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            rules={{ required: true }}
                                            render={({ field: { value, onChange } }) => (
                                                <DatePicker
                                                    minDate={new Date()}
                                                    inputFormat="DD/MM/YYYY"
                                                    rules={{ required: true }}
                                                    error={errors?.comparisonDate}
                                                    value={value}
                                                    disabled={watch('status') != 0}
                                                    onChange={onChange}
                                                    label="Comparison Date"
                                                    labelTop
                                                />
                                            )}
                                            control={control}
                                            name="comparisonDate"
                                        />
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            rules={{ required: true }}
                                            render={({ field: { value, onChange } }) => (
                                                <DatePicker
                                                    minDate={new Date()}
                                                    inputFormat="DD/MM/YYYY"
                                                    error={errors?.comparisondeadline}
                                                    value={value}
                                                    onChange={onChange}
                                                    disabled={watch('status') != 0}
                                                    label="Comparison Deadline"
                                                    labelTop
                                                />
                                            )}
                                            control={control}
                                            name="comparisondeadline"
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            render={({ field: { value, onChange } }) => (
                                                <EntryDate disabled label="Entry Date" value={value}
                                                    setValue={onChange} />
                                            )}
                                            control={control}
                                            name="entryDate"
                                        />
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            render={({ field: { value, onChange } }) => (
                                                <EntryDate disabled label="Sent Date" value={value}
                                                    setValue={onChange} />
                                            )}
                                            control={control}
                                            name="sentDate"
                                        />
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            rules={{ required: true }}
                                            render={({ field: { value, onChange } }) => (
                                                <EntryDate disabled label="Required On Site Date" value={value}
                                                    setValue={onChange} />
                                            )}
                                            control={control}
                                            name="requiredOnSiteDate"
                                        />
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            rules={{ required: true }}
                                            render={({ field: { value, onChange } }) => (
                                                <EntryDate disabled label="Desired Delivery Date" value={value}
                                                    setValue={onChange} />
                                            )}
                                            control={control}
                                            name="desiredDeliveryDate"
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={xsColumn} sm={smColumn} md={mdColumn} lg={lgColumn} xl={xlColumn}>
                                    <Box sx={{ mb: 2 }}>
                                        <Controller
                                            rules={{ required: true }}
                                            render={({ field: { value, onChange } }) => (
                                                <RFQBuyers
                                                    isDisabled
                                                    error={errors?.buyer}
                                                    data={buyers?.data}
                                                    value={value}
                                                    setValue={onChange}
                                                />
                                            )}
                                            control={control}
                                            name="buyer"
                                        />
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <SelectForm
                                            data={approvalStages?.data}
                                            label="Approval Stages"
                                            disabled={watch('status') != 0}
                                            control={control}
                                            name="approveStageName"
                                            id="approveStageMainId"
                                            dynamicField="approveStageMain"
                                        />
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <SelectForm
                                            data={bidComparsionApprovalStatuses}
                                            disabled
                                            label="Approval Status"
                                            control={control}
                                            name="approvalStatusName"
                                            id="approvalStatusId"
                                            dynamicField="approveStatus"
                                        />
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <TextForm
                                            disabled={watch('status') != 0}
                                            control={control}
                                            dynamicField="specialistComment"
                                            label="Specialist Comment"
                                            multiline
                                            rows={4}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            xs={xsGrid2}
                            sm={smGrid2}
                            md={mdGrid2}
                            lg={lgGrid2}
                            xl={xlGrid2}
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Hidden smDown mdDown lgDown>
                                <Divider orientation="vertical" flexItem>
                                    <IconButton onClick={handleClick}>
                                        {open ? <ArrowCircleRightOutlinedIcon /> : <ArrowCircleLeftOutlinedIcon />}
                                    </IconButton>
                                </Divider>
                            </Hidden>

                            <Box sx={{ height: 240 }}>
                                <Collapse in={open}>{open ? <PaginationSystem /> : <Hidden />}</Collapse>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
                <BidChart isLoading={isLoading} setBidMainId={setBidMainId} />
                <ApprovalInformations data={comparsionData?.data?.approvalInformations} />
            </Box>
        </Grid>
    )
}

export default Card
